var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "klaviyo-form",
      class: _vm.embedClass,
      attrs: { method: "GET", "accept-charset": "UTF-8" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "form_type", value: "customer" }
      }),
      _c("input", {
        attrs: { type: "hidden", name: "g" },
        domProps: { value: _vm.listId }
      }),
      !_vm.isSuccess
        ? _c(
            "div",
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentValue,
                    expression: "currentValue"
                  }
                ],
                staticClass: "input text-input--email-capture",
                class: _vm.inputClasses,
                attrs: {
                  id: "email_signup",
                  label: "Email Address",
                  required: "",
                  type: "email",
                  name: "email",
                  placeholder: _vm.placeholder,
                  "email-capture": ""
                },
                domProps: { value: _vm.currentValue },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  }
                }
              }),
              _c("checkbox-input", { ref: "consentCheckbox" }, [
                _vm._v("By signing up, you are accepting our "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://www.generalmills.com/privacy-security/us-english-privacy-policy",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Privacy Policy")]
                ),
                _vm._v(
                  " and agreeing that your information may be used across our "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.generalmills.com/food-we-make/brands",
                      target: "_blank"
                    }
                  },
                  [_vm._v("family of brands")]
                ),
                _vm._v(".")
              ]),
              _vm.valueIsErroneous
                ? _c(
                    "div",
                    {
                      staticClass: "form-input__error-message",
                      attrs: { role: "alert" }
                    },
                    [_vm._v(_vm._s(_vm.errorMessage))]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("transition", { attrs: { name: "slideIn" } }, [
        _vm.isSuccess && _vm.message
          ? _c("div", {
              staticClass: "form-input__success-message",
              attrs: { role: "alert" },
              domProps: { innerHTML: _vm._s(_vm.message) }
            })
          : _vm._e()
      ]),
      _vm.notSubmitted
        ? _c("v-button", {
            staticClass: "btn--primary",
            attrs: { label: "subscribe", type: "submit" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }